import { isRouteErrorResponse, useRouteError } from "react-router";
import { ErrorState, NotFound, PermissionDenied, SessionExpired } from "@/components/states";
import { ApiError } from "@/lib/api";

/** Last stop for anything a screen did not handle. */
export function RouteError() {
  const error = useRouteError();

  if (error instanceof ApiError) {
    if (error.kind === "permission-denied") return <PermissionDenied />;
    if (error.kind === "session-expired") return <SessionExpired />;
    if (error.kind === "not-found") return <NotFound />;
  }
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />;

  return (
    <div className="p-4">
      <ErrorState error={error} onRetry={() => window.location.reload()} />
    </div>
  );
}
